import { NSTable } from 'bricks';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import { ITenant } from 'views/ProFormaSetup/types';
import { ITenantDataCenter, ITotalRentalIncome } from 'views/ProFormaTable/types';
import RenderIf from 'components/RenderIf/RenderIf';
import './RentRollTable.scss';

interface Props {
    tenants: ITenant[] | ITenantDataCenter[];
    totals: ITotalRentalIncome;
    isDataCenter?: boolean;
}

const RentRollTable = ({ tenants, totals, isDataCenter }: Props) => (
    <div className="RentRollTable">
        <div className="text-primary ml-2 mt-2 pb-0">RENT ROLL</div>
        <NSTable className="NSTable mb-0">
            <thead className="NSTable__thead">
                <tr className="NSTable__thead__tr">
                    <th className="NSTable__thead__tr__th pb-1 text-left text-dark">Tenants</th>
                    <th className="NSTable__thead__tr__th pb-1 text-right text-dark">RSF</th>
                    <th className="NSTable__thead__tr__th pb-1 text-right text-dark">$/RSF/year</th>
                    <th className="NSTable__thead__tr__th pb-1 text-right text-dark">Pro forma rent</th>
                </tr>
            </thead>
            <tbody className="NSTable__tbody">
                {tenants.map(tenant => {
                    const dataCenterTenant = tenant as ITenantDataCenter;
                    const regularTenant = tenant as ITenant;

                    return (
                        <tr key={`tenant-${tenant.id}`} className="NSTable__tbody__tr">
                            <td className="NSTable__tbody__tr__td py-1 text-left">{tenant.tenant}</td>
                            <td className="NSTable__tbody__tr__td py-1 text-right text-dark">
                                <RenderIf isTrue={isDataCenter}>
                                    {dataCenterTenant.squareFootage?.toLocaleString() ?? '-'}
                                </RenderIf>
                                <RenderIf isTrue={!isDataCenter}>
                                    {regularTenant.squareFootage?.toLocaleString() ?? '-'}
                                </RenderIf>
                            </td>
                            <td className="NSTable__tbody__tr__td py-1 text-right text-dark">
                                <RenderIf isTrue={isDataCenter}>
                                    {dataCenterTenant.annualRent && dataCenterTenant.squareFootage
                                        ? numeralFormatterCurrency(
                                            dataCenterTenant.annualRent / dataCenterTenant.squareFootage,
                                            '$0,0',
                                        )
                                        : '-'}
                                </RenderIf>
                                <RenderIf isTrue={!isDataCenter}>
                                    {regularTenant.valuePerSfPerYear != null
                                        ? numeralFormatterCurrency(regularTenant.valuePerSfPerYear, '$0,0')
                                        : '-'}
                                </RenderIf>
                            </td>
                            <td className="NSTable__tbody__tr__td py-1 text-right text-dark">
                                {tenant.annualRent != null
                                    ? numeralFormatterCurrency(tenant.annualRent, '$0,0')
                                    : '-'}
                            </td>
                        </tr>
                    );
                })}
                <tr className="NSTable__tbody__tr">
                    <td className="NSTable__tbody__tr__td pt-1 text-left">Total/avg</td>
                    <td className="NSTable__tbody__tr__td pt-1 text-right text-dark">
                        {totals?.totalSquareFootage?.toLocaleString() ?? '-'}
                    </td>
                    <td className="NSTable__tbody__tr__td pt-1 text-right text-dark">
                        {totals?.totalValuePerSfPerYear != null
                            ? numeralFormatterCurrency(totals.totalValuePerSfPerYear, '$0,0')
                            : '-'}
                    </td>
                    <td className="NSTable__tbody__tr__td pt-1 text-right text-dark">
                        {totals?.totalAnnualRent != null
                            ? numeralFormatterCurrency(totals.totalAnnualRent, '$0,0')
                            : '-'}
                    </td>
                </tr>
            </tbody>
        </NSTable>
    </div>
);

export default RentRollTable;
